import HC from "@material-ui/icons/HomeOutlined";
import { makeThemedStyles } from "qpr-base/viewcomponents/utils";
import React from "react";

const useBreadcrumbsHomeIconStyles = makeThemedStyles(
  "Breadcrumbs.HomeIcon",
  (theme) => ({
    root: {
      width: "28px",
      height: "28px",
      fontSize: "28px",
      color: "rgba(0, 0, 0, 0.55)",
      "&:hover": { color: "rgba(0, 0, 0, 0.85)" },
    },
  })
);

const HomeIcon = () => {
  const classes: any = useBreadcrumbsHomeIconStyles();
  const { HomeIcon, ...other } = classes;
  return <HC classes={other} />;
};

export default HomeIcon;
